<template>
    <div class='control w-full h-full flex column p-20 border-box'>
        <div v-if="platform_control">
            <div class="table-header">Platform Control</div>

            <div class="content p-20 flex column gap-20">
                <InpComponent
                    :noMargin="true"
                    :label="'FIU Monthly Price (€)'"
                    :value="platform_control.fiu_monthly_price"
                    type="number"
                    @inputChange="platform_control.fiu_monthly_price = $event[1];"
                    :error="errors.fiu_monthly_price"
                />
                <InpComponent
                    :noMargin="true"
                    :label="'FIU Row Price (€)'"
                    type="number"
                    :value="platform_control.fiu_report_price"
                    @inputChange="platform_control.fiu_report_price = $event[1];"
                    :error="errors.fiu_report_price"
                />
                <InpComponent
                    :noMargin="true"
                    :label="'Kyc Monthly Price (€)'"
                    type="number"
                    :value="platform_control.kyc_monthly_price"
                    @inputChange="platform_control.kyc_monthly_price = $event[1]"
                    :error="errors.kyc_monthly_price"
                />
                <InpComponent
                    :noMargin="true"
                    :label="'Sanction Screening Monthly Price (€)'"
                    type="number"
                    :value="platform_control.sanction_screening_report_price"
                    @inputChange="platform_control.sanction_screening_report_price = $event[1]"
                    :error="errors.sanction_screening_report_price"
                />
                <InpComponent
                    :noMargin="true"
                    :label="'Due Diligence Monthly Price (€)'"
                    type="number"
                    :value="platform_control.due_dilligence_monthly_price"
                    @inputChange="platform_control.due_dilligence_monthly_price = $event[1]"
                    :error="errors.due_dilligence_monthly_price"
                />
                <Toggle
                    :value="platform_control.emails_send_out"
                    :options="[
                        { label: 'Disabled', value: 'NO' },
                        { label: 'Enabled', value: 'YES' },
                    ]"
                    @change="(val) => platform_control.emails_send_out = val"
                    :label="'Email Send out'"
                />  
                <Toggle
                    :value="platform_control.rate_scheduler_enabled"
                    :options="[
                        { label: 'Disabled', value: false },
                        { label: 'Enabled', value: true },
                    ]"
                    @change="(val) => platform_control.rate_scheduler_enabled = val"
                    :label="'Rate Scheduler'"
                /> 
                <Toggle
                    :value="platform_control.kyc_section_available_default"
                    :options="[
                        { label: 'Disabled', value: false },
                        { label: 'Enabled', value: true },
                    ]"
                    @change="(val) => platform_control.kyc_section_available_default = val"
                    :label="'Kyc Section Available Default'"
                /> 
                <Toggle
                    :value="platform_control.fiu_section_available_default"
                    :options="[
                        { label: 'Disabled', value: false },
                        { label: 'Enabled', value: true },
                    ]"
                    @change="(val) => platform_control.fiu_section_available_default = val"
                    :label="'FIU Section Available Default'"
                /> 
                <Toggle
                    :value="platform_control.due_diligence_section_available_default"
                    :options="[
                        { label: 'Disabled', value: false },
                        { label: 'Enabled', value: true },
                    ]"
                    @change="(val) => platform_control.due_diligence_section_available_default = val"
                    :label="'Due Dilligence Section Available Default'"
                /> 
                <Toggle
                    :value="platform_control.sanctions_screening_section_available_default"
                    :options="[
                        { label: 'Disabled', value: false },
                        { label: 'Enabled', value: true },
                    ]"
                    @change="(val) => platform_control.sanctions_screening_section_available_default = val"
                    :label="'Sanction Screaning Section Available Default'"
                /> 
                <button @click="saveChanges()">Save Changes</button>
            </div>
        </div>
        <div v-else>
            <h1>Loading...</h1>
        </div>
    </div>
</template>


<script setup>

    import InpComponent from '@/components/InpComponent.vue'
    import Toggle from '@/elements/Toggle.vue';
    import BO_API from '../api/bo_api.js'
    import store from '../store';
    import { ref, computed, onMounted } from 'vue';

    const platform_control = ref(null)
    const errors = ref({})
    async function loadPlatformControl(){
        const resp = await BO_API.getPlatformControl()
        if (resp.platformControl) {
            platform_control.value = resp.platformControl
        }
    }
  
    function validateInputs(){
        const newErrors = {}
        if (platform_control.value.fiu_monthly_price < 0) {
            newErrors.fiu_monthly_price = 'FIU Monthly Price cannot be negative'
        }
        if (platform_control.value.fiu_report_price < 0) {
            newErrors.fiu_report_price = 'FIU Row Price cannot be negative'
        }
        if (platform_control.value.kyc_monthly_price < 0) {
            newErrors.kyc_monthly_price = 'KYC Monthly Price cannot be negative'
        }
        if (platform_control.value.sanction_screening_report_price < 0) {
            newErrors.sanction_screening_report_price = 'Sanction Screening Monthly Price cannot be negative'
        }
        if (platform_control.value.due_dilligence_monthly_price < 0) {
            newErrors.due_dilligence_monthly_price = 'Due Diligence Monthly Price cannot be negative'
        }
        for(const key in newErrors) {
            store.dispatch('addNotification', { text: newErrors[key], type: 'error' })
        }
        return Object.keys(newErrors).length === 0
    }

    async function saveChanges() {
        const validationResponse = validateInputs()
        if (!validationResponse) {
            return
        }
        const resp = await BO_API.updatePlatformControl(platform_control.value)
        if (resp.status == 200) {
            store.dispatch('addNotification', {text: 'Changes saved', type: 'success'})
        }   
    }
    onMounted(() => {
        loadPlatformControl()
    })


</script>

<style scoped lang="scss">
    .content {
        width: 400px;
        border: 1px solid var(--border-color);
        border-radius: 10px;
        background: white;
    }
    .control {

        width: 100%;
        height: calc(100vh - 61px);
        display: flex;
    }
    .input-wrapper {
        :deep(div label) {
            color: black;
        }
    }
    button {
        padding: 10px;
        font-size: 15px;
    }
    .table-header {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
        text-align: left;
        color: black;
        padding-top: 20px;
    }
</style>
